import { Action } from 'redux';

import { isFetchPrivateConnectionsRequest, isFetchPrivateConnectionsRequestSucceeded } from '../actions/FetchPrivateConnectionsRequestAction';
import { IPrivateConnectInfo } from '../models/PrivateConnectModels';

const InitialState: IPrivateConnectInfo = {
    privateConnections: [],
    isFetchingPrivateConnections: false
};

export function privateConnectReducer(
  previousState: IPrivateConnectInfo= InitialState,
  action: Action
): IPrivateConnectInfo {
    if(isFetchPrivateConnectionsRequest(action)){
        return {
            ...previousState,
            isFetchingPrivateConnections: true
        };
    }
    else if (isFetchPrivateConnectionsRequestSucceeded(action)) {
        return {
            ...previousState,
            privateConnections: action?.privateConnections ?? [],
            isFetchingPrivateConnections: false
        };
    }
    return previousState;
}